import { ClassificationType, SearchInstanceDto } from '@app/components';

export const formatClassifications = (
  classificationName: ClassificationType,
  classifications: SearchInstanceDto['classifications'] = []
) => {
  return classifications
    .filter(
      ({ classificationTypeName }) =>
        classificationTypeName === classificationName
    )
    .map(({ classificationNumber }) => classificationNumber);
};
